/* =====================================================================================================
   Blazee · galeria em tela cheia da PDP (porte do protótipo blazee-prototipos/tipografia/pdp/_zoom.html)

   API: window.BlzZoom.abrir(lista, indice, origem)
     lista  = [{ p: url ~1300px, z: url ~2600px, t: url miniatura, w, h, alt }]
     indice = foto que abre
     origem = elemento que recebe o foco de volta ao fechar
   Quem chama é o assets/blz-produto.js (clique nas fotos da abertura, da galeria e da ficha).

   Zoom: clique (mouse) ou toque duplo amplia no ponto; pinça (celular e trackpad) e Ctrl+roda ajustam; o botão + / −
   e as teclas + − 0 também. Com zoom, arrastar move a foto.
   Passar: setas na tela, teclado (← →), deslizar para o lado (sem zoom), roda do mouse ou miniaturas.
   Fechar: ×, Esc, botão voltar do celular ou deslizar para baixo.
   Fundo branco puro, igual ao estúdio das fotos; nada de filtro, opacidade ou véu sobre a foto.
   ===================================================================================================== */
(function () {
  'use strict';
  if (window.BlzZoom) return;

  var mobile = matchMedia('(max-width: 749px)'), fine = matchMedia('(hover: hover) and (pointer: fine)');
  var MAXS = 4, TAPS = 2.5;
  var ICON = {
    x: '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M2 2l14 14M16 2L2 16"/></svg>',
    plus: '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M9 2v14M2 9h14"/></svg>',
    minus: '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M2 9h14"/></svg>',
    l: '<svg viewBox="0 0 22 22" aria-hidden="true"><path d="M14 3L6 11l8 8"/></svg>',
    r: '<svg viewBox="0 0 22 22" aria-hidden="true"><path d="M8 3l8 8-8 8"/></svg>'
  };
  var esc = function (t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };

  var el, track, count, thumbs, hint, zbtn, prev, next;
  var list = [], slides = [], idx = 0, isOpen = false, opener = null, pushed = false;
  var z = { s: 1, x: 0, y: 0 };

  function build() {
    el = document.createElement('div');
    el.className = 'pz';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Fotos do produto em tela cheia');
    el.tabIndex = -1;
    el.innerHTML = '<div class="pz-track"></div>' +
      '<div class="pz-top"><p class="pz-count tk-meta" aria-live="polite"></p><div class="pz-tools">' +
        '<button type="button" class="pz-btn" data-z aria-label="Ampliar">' + ICON.plus + '</button>' +
        '<button type="button" class="pz-btn" data-x aria-label="Fechar">' + ICON.x + '</button></div></div>' +
      '<button type="button" class="pz-nav pz-prev" data-prev aria-label="Foto anterior">' + ICON.l + '</button>' +
      '<button type="button" class="pz-nav pz-next" data-next aria-label="Próxima foto">' + ICON.r + '</button>' +
      '<div class="pz-thumbs" data-thumbs></div>' +
      '<p class="pz-hint tk-meta" data-hint></p>';
    document.body.appendChild(el);
    track = el.querySelector('.pz-track');
    count = el.querySelector('.pz-count');
    thumbs = el.querySelector('[data-thumbs]');
    hint = el.querySelector('[data-hint]');
    zbtn = el.querySelector('[data-z]');
    prev = el.querySelector('[data-prev]');
    next = el.querySelector('[data-next]');

    el.querySelector('[data-x]').addEventListener('click', close);
    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    zbtn.addEventListener('click', function () {
      if (z.s > 1.01) reset(true);
      else zoomAt(innerWidth / 2, innerHeight / 2, TAPS, true);
    });
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-i]');
      if (b) go(+b.dataset.i);
    });
    el.addEventListener('pointerdown', down);
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
    el.addEventListener('wheel', wheel, { passive: false });
    el.addEventListener('gesturestart', function (e) { e.preventDefault(); });  // Safari: a pinça é nossa, não da página
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    addEventListener('resize', function () { if (isOpen) { layout(); reset(false); } });
  }

  // ---------- montagem dos slides ----------
  function fill() {
    track.innerHTML = list.map(function (m, i) {
      return '<div class="pz-slide" aria-hidden="true"><img class="pz-img" draggable="false" alt="' +
        esc(m.alt) + ' — foto ' + (i + 1) + ' de ' + list.length + '"></div>';
    }).join('');
    slides = Array.prototype.map.call(track.children, function (s, i) {
      return { el: s, im: s.firstChild, m: list[i], r: null, loaded: false };
    });
    thumbs.innerHTML = list.map(function (m, i) {
      return '<button type="button" data-i="' + i + '" aria-label="Foto ' + (i + 1) + '" style="background-image:url(\'' + esc(m.t) + '\')"></button>';
    }).join('');
    thumbs.style.display = list.length < 2 ? 'none' : '';
  }
  function pads() {
    return mobile.matches ? { t: 52, b: 40, l: 0, r: 0 } : { t: 64, b: 96, l: 88, r: 88 };
  }
  function layout() {
    var VW = el.clientWidth, VH = el.clientHeight, p = pads();
    slides.forEach(function (s) {
      var w = s.m.w || s.im.naturalWidth || 4, h = s.m.h || s.im.naturalHeight || 5;
      var aw = VW - p.l - p.r, ah = VH - p.t - p.b, k = Math.min(aw / w, ah / h);
      var W = w * k, H = h * k, x = p.l + (aw - W) / 2, y = p.t + (ah - H) / 2;
      s.r = { x: x, y: y, w: W, h: H };
      s.im.style.left = x + 'px'; s.im.style.top = y + 'px';
      s.im.style.width = W + 'px'; s.im.style.height = H + 'px';
    });
  }
  // a foto em tamanho de página aparece na hora (já está em cache); a de alta resolução entra quando termina de baixar
  function load(i) {
    var s = slides[i];
    if (!s || s.loaded) return;
    s.loaded = true;
    s.im.src = s.m.p;
    var hi = new Image();
    hi.src = s.m.z;
    var swap = function () { s.im.src = hi.src; };
    if (hi.decode) hi.decode().then(swap, function () {}); else hi.onload = swap;
  }

  // ---------- zoom ----------
  function cur() { return slides[idx]; }
  function apply(anim) {
    var s = cur();
    if (!s) return;
    s.im.classList.toggle('anim', !!anim);
    s.im.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
    var on = z.s > 1.01;
    el.classList.toggle('zoomed', on);
    zbtn.innerHTML = on ? ICON.minus : ICON.plus;
    zbtn.setAttribute('aria-label', on ? 'Reduzir' : 'Ampliar');
    if (on) quiet();
  }
  function clamp() {
    var r = cur().r, VW = el.clientWidth, VH = el.clientHeight, W = r.w * z.s, H = r.h * z.s;
    if (z.s <= 1) { z.s = 1; z.x = 0; z.y = 0; return; }
    z.x = W <= VW ? (r.w - W) / 2 : Math.min(-r.x, Math.max(VW - r.x - W, z.x));
    z.y = H <= VH ? (r.h - H) / 2 : Math.min(-r.y, Math.max(VH - r.y - H, z.y));
  }
  function local(px, py) { var r = cur().r; return { x: (px - r.x - z.x) / z.s, y: (py - r.y - z.y) / z.s }; }
  function zoomAt(px, py, s2, anim) {
    var r = cur().r, q = local(px, py);
    z.s = Math.max(1, Math.min(MAXS, s2));
    z.x = px - r.x - z.s * q.x;
    z.y = py - r.y - z.s * q.y;
    clamp(); apply(anim);
  }
  function reset(anim) { z = { s: 1, x: 0, y: 0 }; apply(anim); }
  function inside(px, py) { var r = cur().r; return px >= r.x && px <= r.x + r.w && py >= r.y && py <= r.y + r.h; }

  // ---------- navegação ----------
  function pad(n) { return String(n).padStart(2, '0'); }
  function quiet() { hint.classList.add('off'); }
  function go(i, instant) {
    i = Math.max(0, Math.min(list.length - 1, i));
    if (slides[idx] && i !== idx) { z = { s: 1, x: 0, y: 0 }; apply(false); }
    idx = i;
    track.classList.toggle('anim', !instant);
    track.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)';
    slides.forEach(function (s, k) { s.el.setAttribute('aria-hidden', String(k !== idx)); });
    z = { s: 1, x: 0, y: 0 }; apply(false);
    count.textContent = pad(idx + 1) + ' / ' + pad(list.length);
    Array.prototype.forEach.call(thumbs.children, function (b, k) {
      b.setAttribute('aria-current', String(k === idx));
      if (k === idx && b.scrollIntoView && !mobile.matches) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    prev.disabled = idx === 0; next.disabled = idx === list.length - 1;
    load(idx); load(idx + 1); load(idx - 1);
  }

  // ---------- abrir / fechar ----------
  var saved = '';
  function open(gal, i, from) {
    if (!gal || !gal.length) return;
    if (!el) build();
    list = gal; opener = from || null;
    fill();
    el.classList.remove('calm');
    el.classList.add('on');
    isOpen = true;
    saved = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    layout();
    go(i || 0, true);
    hint.textContent = fine.matches ? 'Clique na foto para ampliar' : 'Toque duas vezes para ampliar';
    hint.classList.remove('off');
    clearTimeout(open.t); open.t = setTimeout(quiet, 3800);
    el.focus({ preventScroll: true });  // o foco entra na galeria sem desenhar contorno no × (Tab chega nos botões)
    // botão voltar do celular fecha a galeria em vez de sair da página
    try { history.pushState({ pz: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
  }
  function shut() {
    if (!isOpen) return;
    isOpen = false;
    el.classList.remove('on', 'zoomed', 'grabbing');
    el.style.backgroundColor = '';
    document.documentElement.style.overflow = saved;
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }
  function close() {
    if (pushed && history.state && history.state.pz) { pushed = false; history.back(); }  // o popstate fecha
    else { pushed = false; shut(); }
  }
  addEventListener('popstate', function () { if (isOpen) { pushed = false; shut(); } });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    var k = e.key, done = true;
    if (k === 'Escape') close();
    else if (k === 'ArrowRight') go(idx + 1);
    else if (k === 'ArrowLeft') go(idx - 1);
    else if (k === '+' || k === '=') zoomAt(innerWidth / 2, innerHeight / 2, z.s * 1.6, true);
    else if (k === '-' || k === '_') zoomAt(innerWidth / 2, innerHeight / 2, z.s / 1.6, true);
    else if (k === '0') reset(true);
    else if (k === 'Tab') {  // o foco fica dentro da galeria
      var f = Array.prototype.filter.call(el.querySelectorAll('button'), function (b) { return !b.disabled && b.offsetParent; });
      var at = f.indexOf(document.activeElement), n = (at + (e.shiftKey ? -1 : 1) + f.length) % f.length;
      if (f[n]) f[n].focus();
    } else done = false;
    if (done) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  // ---------- gestos: um dedo (passar, mover, puxar para fechar), dois dedos (pinça), toque/duplo toque ----------
  var pts = new Map(), g = null, lastTap = 0, lastPt = null, tapT = 0;
  function two() { var a = Array.from(pts.values()); return { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1, x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }; }
  function down(e) {
    if (e.target.closest('button')) return;
    try { el.setPointerCapture(e.pointerId); } catch (_) {}
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 1) {
      g = { k: 'one', x0: e.clientX, y0: e.clientY, zx: z.x, zy: z.y, t0: Date.now(), moved: false, axis: '', type: e.pointerType };
    } else if (pts.size === 2) {
      var m = two();
      track.classList.remove('anim'); track.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)';
      g = { k: 'pinch', d0: m.d, s0: z.s, q: local(m.x, m.y) };
    }
  }
  function move(e) {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (!g) return;
    if (g.k === 'pinch' && pts.size >= 2) {
      var m = two(), r = cur().r;
      z.s = Math.max(1, Math.min(MAXS, g.s0 * m.d / g.d0));
      z.x = m.x - r.x - z.s * g.q.x; z.y = m.y - r.y - z.s * g.q.y;
      clamp(); apply(false);
      return;
    }
    var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
    if (!g.moved && Math.hypot(dx, dy) > 6) {
      g.moved = true;
      g.axis = z.s > 1.01 ? 'pan' : Math.abs(dx) >= Math.abs(dy) ? 'x' : (dy > 0 && g.type !== 'mouse' ? 'pull' : 'none');
      if (g.axis === 'pan') el.classList.add('grabbing');
      if (g.axis === 'x' || g.axis === 'pull') track.classList.remove('anim');
    }
    if (!g.moved) return;
    if (g.axis === 'pan') { z.x = g.zx + dx; z.y = g.zy + dy; clamp(); apply(false); }
    else if (g.axis === 'x') {
      var edge = (idx === 0 && dx > 0) || (idx === list.length - 1 && dx < 0);
      track.style.transform = 'translate3d(calc(' + (-idx * 100) + '% + ' + (edge ? dx / 3 : dx) + 'px),0,0)';
    } else if (g.axis === 'pull') {
      // puxar para baixo: só o fundo da galeria clareia até a página; a foto continua inteira
      track.style.transform = 'translate3d(' + (-idx * 100) + '%,' + Math.max(0, dy) + 'px,0)';
      el.style.backgroundColor = 'rgba(255,255,255,' + Math.max(.4, 1 - dy / 600) + ')';
    }
  }
  function up(e) {
    if (!pts.has(e.pointerId)) return;
    pts.delete(e.pointerId);
    if (!g) return;
    if (g.k === 'pinch') {
      if (pts.size === 1) { var p = Array.from(pts.values())[0]; g = { k: 'one', x0: p.x, y0: p.y, zx: z.x, zy: z.y, moved: true, axis: z.s > 1.01 ? 'pan' : 'none', type: 'touch' }; }
      else if (!pts.size) { g = null; if (z.s < 1.05) reset(true); }
      return;
    }
    if (pts.size) return;
    var dx = e.clientX - g.x0, dy = e.clientY - g.y0, dt = Math.max(1, Date.now() - g.t0);
    el.classList.remove('grabbing');
    if (!g.moved) tap(e, g.type);
    else if (g.axis === 'x') {
      var fast = Math.abs(dx) / dt > .5;
      go(idx + (dx < -60 || (fast && dx < -20) ? 1 : dx > 60 || (fast && dx > 20) ? -1 : 0));
    } else if (g.axis === 'pull') {
      el.style.backgroundColor = '';
      if (dy > 110 || dy / dt > .6) { track.classList.remove('anim'); close(); setTimeout(function () { track.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)'; }, 30); }
      else go(idx);
    }
    g = null;
  }
  function tap(e, type) {
    var x = e.clientX, y = e.clientY;
    if (type === 'mouse') {
      if (z.s > 1.01) reset(true);
      else if (inside(x, y)) zoomAt(x, y, TAPS, true);
      return;
    }
    // toque: duplo toque amplia/volta; toque simples esconde/mostra os controles
    var now = Date.now();
    if (now - lastTap < 300 && lastPt && Math.hypot(x - lastPt.x, y - lastPt.y) < 40) {
      clearTimeout(tapT); lastTap = 0;
      if (z.s > 1.01) reset(true); else zoomAt(x, y, TAPS, true);
    } else {
      lastTap = now; lastPt = { x: x, y: y };
      clearTimeout(tapT); tapT = setTimeout(function () { el.classList.toggle('calm'); }, 300);
    }
  }
  var wheelIdle = 0, wheelUsed = false;
  function wheel(e) {
    e.preventDefault();
    if (e.ctrlKey) { zoomAt(e.clientX, e.clientY, z.s * Math.exp(-e.deltaY * .01), false); return; }  // pinça do trackpad
    if (z.s > 1.01) { z.x -= e.deltaX; z.y -= e.deltaY; clamp(); apply(false); return; }
    // sem zoom: um gesto de rolagem passa uma foto (a inércia do trackpad não pula várias)
    clearTimeout(wheelIdle); wheelIdle = setTimeout(function () { wheelUsed = false; }, 220);
    var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    if (wheelUsed || Math.abs(d) < 8) return;
    wheelUsed = true; go(idx + (d > 0 ? 1 : -1));
  }

  window.BlzZoom = { abrir: open, fechar: close, aberta: function () { return isOpen; } };
})();
